import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Selection,
} from '@nextui-org/react'
import { useEffect } from 'react'
import useChartStore from '../../store/chart/useChartStore'
import { useAuthStore } from '../../store/auth/useAuthStore'
import { Properties, PropertiesWithoutWater } from './config'
import { PropertyName } from '../../types/apiResponse/chartTypes'
import './SelectProperties.css'

export const SelectProperties = () => {
  const { properties, setProperties } = useChartStore()
  const { userId } = useAuthStore()

  // Set all properties as selected by default when component mounts
  useEffect(() => {
    if (properties.length === 0) {
      const allProperties = Object.keys(
        userId === 'fishcafe@tidepool.kr' ? PropertiesWithoutWater : Properties,
      ) as PropertyName[]
      setProperties(allProperties)
    }
  }, [userId, properties.length, setProperties])

  const onSelectionChange = (keys: Selection) => {
    if (keys === 'all') {
      // Handle "all" selection - set all available properties
      const allProperties = Object.keys(
        userId === 'fishcafe@tidepool.kr' ? PropertiesWithoutWater : Properties,
      ) as PropertyName[]
      setProperties(allProperties)
    } else {
      const selectedProperties = Array.from(keys) as PropertyName[]
      
      // Don't allow unselecting when only 1 property is left
      if (selectedProperties.length === 0 && properties.length === 1) {
        return // Do nothing, keep the last property selected
      }
      
      setProperties(selectedProperties)
    }
  }

  return (
    <Dropdown className="flex ml-auto">
      <DropdownTrigger>
        <Button
          variant="bordered"
          className="font-bold capitalize border border-opacity-0 text-tdplprussian"
        >
          Properties ▾
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Select Properties"
        selectionMode="multiple"
        closeOnSelect={false}
        selectedKeys={properties}
        onSelectionChange={onSelectionChange}
        className="properties-dropdown-menu"
      >
        {Object.entries(
          userId === 'fishcafe@tidepool.kr' ? PropertiesWithoutWater : Properties,
        ).map((item) => {
          return (
            <DropdownItem className="text-tdplprussian" key={item[0]}>
              {item[1]}
            </DropdownItem>
          )
        })}
      </DropdownMenu>
    </Dropdown>
  )
}
